import React from 'react'
import { ProgressCircle } from '@creditas-ui/react'
import { Container } from './styles'
import i18n from '~/i18n/i18n'

const PageLoading = () => (
  <Container>
    <ProgressCircle
      size="large"
      accessibilityMessage={i18n.t('commons:status.loading')}
    />
  </Container>
)

export { PageLoading }
